import React from "react";
import { Button, Space, Table, Tag } from "antd";
import { FileSearchOutlined } from "@ant-design/icons";
import { getModuleGroups } from "../Home/Constants";
import { useTheme } from "../../services/useTheme";

const labelToId = {
  Skeyenote: "skeyenote",
  Skeyechart: "skeyecharts",
  Skeyeingest: "skeyeingest",
  Skeyeform: "skeyeform",
  Skeyecube: "skeyecube",
  Skeyepredict: "skeyepredict",
  Hadoop: "hadoop",
  Spark: "spark",
  Hive: "hive",
  DGHelper: "dghelper",
  Fahras: "fahras",
  Jeyeda: "jeyeda",
};

/* const logoById = Object.values(getModuleGroups())
  .flat()
  .reduce((acc, item) => {
    acc[item.id] = item.logo;
    return acc;
  }, {}); */

export default function InstancesTable({
  data,
  loading,
  isBackendDown,
  onOpenLogs,
  page,
  pageSize,
  onPageChange,
}) {
  const isDarkTheme = useTheme();

  const logoById = React.useMemo(() => {
    return Object.values(getModuleGroups(isDarkTheme))
      .flat()
      .reduce((acc, item) => {
        acc[item.id] = item.logo;
        return acc;
      }, {});
  }, [isDarkTheme]);

  const columns = React.useMemo(
    () => [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: 410,
        ellipsis: true,
        render: (name, row) => {
          const moduleId = labelToId[row.label];
          const logo = moduleId ? logoById[moduleId] : null;

          return (
            <span
              style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
            >
              {logo && !row.isTotal && (
                <img
                  src={logo}
                  alt={row.label}
                  style={{ width: 25, height: 18, objectFit: "contain" }}
                />
              )}
              <span>{name}</span>
            </span>
          );
        },
      },
      /*  { title: "Module", dataIndex: "label", key: "label" }, */
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (v, row) => {
          // Force UI visually into UNKNOWN (Except for the total summary row)
          if (isBackendDown && !row.isTotal) {
            return <Tag color="default">UNKNOWN</Tag>;
          }
          return (
            <Tag
              color={
                v === "RUNNING" ? "green" : v === "SUMMARY" ? "blue" : "red"
              }
            >
              {v}
            </Tag>
          );
        },
      },
      {
        title: "CPU",
        dataIndex: "cpuUsage",
        key: "cpuUsage",
        render: (v) => (isBackendDown ? "—" : v),
      },
      {
        title: "Memory",
        dataIndex: "memoryUsage",
        key: "memoryUsage",
        render: (v) => (isBackendDown ? "—" : v),
      },
      {
        title: "Disk",
        dataIndex: "diskUsage",
        key: "diskUsage",
        render: (v) => (isBackendDown ? "—" : v),
      },
      {
        title: "Ports",
        dataIndex: "ports",
        key: "ports",
        render: (ports) =>
          isBackendDown || !ports?.length ? "—" : ports.join(", "),
      },
      {
        title: "Actions",
        key: "actions",
        render: (_, row) =>
          row.isTotal ? null : (
            <Space>
              <Button
                icon={<FileSearchOutlined />}
                onClick={() => onOpenLogs(row)}
                size="small"
                disabled={isBackendDown} // <-- Automatically disables button on down status
              >
                Logs
              </Button>
            </Space>
          ),
      },
    ],
    [onOpenLogs, isBackendDown, logoById],
  );

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={{
        current: page,
        pageSize,
        showSizeChanger: true,
        pageSizeOptions: [10, 25, 50, 100],
        onChange: onPageChange,
      }}
      sticky
      size="middle"
      scroll={{ x: 900 }}
    />
  );
}
